/**
 * @file LinkedPairField.tsx
 * @description «⛓ одинаково» для пары полей слева/справа (phase19.16,
 * партия SB120, этап 1; uiux-sb120-stage1 §2.2, вопрос 5 — «связаны по
 * умолчанию, расцепляются одним касанием»; данные db-design-sb120-stage1
 * §1 (г) — связь не хранится: она есть, когда значения равны).
 *
 * Пока связано — одно поле (`linked`), правка пишет обе стороны; расцепили —
 * два поля (`left`, `right`). Сцепить разные — правая берёт значение левой
 * (это делает вызывающий в `onLink`).
 */

import { Link2, Link2Off } from "lucide-react";
import type { ReactNode } from "react";

interface Props {
  linked: boolean;
  /** Сцепить (`true`) или расцепить (`false`). */
  onLink: (linked: boolean) => void;
  /** Подпись пары: «Внутри слева и справа». */
  label: string;
  /** Одно поле на обе стороны — пока сцеплено. */
  both: ReactNode;
  left: ReactNode;
  right: ReactNode;
}

export function LinkedPairField({ linked, onLink, label, both, left, right }: Props) {
  const Icon = linked ? Link2 : Link2Off;
  return (
    <div className="flex min-w-0 flex-col gap-2">
      <button
        type="button"
        aria-pressed={linked}
        aria-label={`${label}: одинаково`}
        onClick={() => onLink(!linked)}
        className="inline-flex h-12 items-center gap-2 self-start rounded-lg bg-surface-low px-3 text-sm font-medium text-on-surface outline-none focus-visible:ring-2 focus-visible:ring-ring aria-pressed:[box-shadow:inset_0_0_0_2px_var(--primary)] can-hover:h-8"
      >
        <Icon aria-hidden className="size-4" />
        {linked ? "Одинаково слева и справа" : "Слева и справа — по-разному"}
      </button>
      {linked ? both : (
        <>
          {left}
          {right}
        </>
      )}
    </div>
  );
}
